<template>
  <div>
    <div v-if="item.editorType == 'Relate'">
      <RelateComponent
        v-model="fieldValue"
        :rRoute="item.editorOptions.relateModule"
        :fieldName="item.dataField"
        :disabled="item.editorOptions.disabled"
        :pRoute="routeDef"
        :slug="prefix"
        v-on:changed="inputChanged()"
      >
      </RelateComponent>
    </div>

    <div v-if="item.editorType == 'Phone'">
      <DxNumberBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>

    <div v-if="item.editorType == 'MultiSelect'">
      <MultiSelectComponent
        v-model="fieldValue"
        :datasource="item.editorOptions.dataSource"
        :pRoute="routeDef"
        :slug="prefix"
      >
      </MultiSelectComponent>
    </div>

    <div v-if="item.editorType == 'dxTextBox'">
      <DxTextBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>
    <div v-if="item.editorType == 'dxNumberBox'">
      <DxNumberBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>
    <!-- dxDateBox -->
    <div v-if="item.editorType == 'dxDateBox'">
      <DxDateBox
        v-model="fieldValue"
        :display-format="item.editorOptions.displayFormat"
        :type="item.editorOptions.type"
        :value="currentDate"
        :disabled="item.editorOptions.disabled"
        @focus-out="onDateFocusOut"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>

    <div v-if="item.editorType == 'userstamp'">
      <UserStampComponent
        v-model="fieldValue"
        :rRoute="item.editorOptions.relateModule"
        :fieldName="item.dataField"
        :disabled="item.editorOptions.disabled"
        :pRoute="routeDef"
        :slug="prefix"
        v-on:changed="inputChanged()"
      >
      </UserStampComponent>
    </div>
  </div>
</template>

<script>
import DxTextBox from "devextreme-vue/text-box";
import DxNumberBox from "devextreme-vue/number-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import DropDataGrid from "./DropDataGrid.vue";
import RelateComponent from "./RelateComponent.vue";
import UserStampComponent from "./UserStampComponent.vue";
import MultiSelectComponent from "./MultiSelectComponent.vue";
const now = new Date();

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";
import MultiSelectComponentVue from "./MultiSelectComponent.vue";

export default {
  props: {
    modelValue: String,
    defaultDate: Boolean,
    item: {
      type: Object,
      default: () => ({}),
    },
    prefix: String,
    routeDef: String,
  },
  components: {
    DropDataGrid,
    DxSimpleItem,
    UserStampComponent,
    DxTextBox,
    DxNumberBox,
    DxDateBox,
    RelateComponent,
    MultiSelectComponent,
  },
  data: function () {
    return {
      fieldValue: this.modelValue,
      selectedLedgerId: "12234",
      currentDate: null,
    };
  },
  methods: {
    inputChanged() {
      // console.log("CSTM Relate", e.value);
    },
    checkValue() {
      console.log(" checkValue CheckBox", this.checkboxValue);
    },

    updateCheckboxValue(value) {
      // Update the checkboxValue when ComponentOne emits the event
      this.checkboxValue = value;
      console.log("updateCheckboxValue value", value);
    },
    onDateFocusOut(e) {
      var dateInputValue = e.event.target.value;

      console.log("onDateFocusOut dateInputValue", dateInputValue);
      if (dateInputValue === "") {
        console.log("onDateFocusOut Inside", dateInputValue);

        if (this.item.dataField != "transaction_date") {
          dateInputValue = null;
          this.$emit("update:modelValue", dateInputValue);
        }
      }
    },
  },
  mounted() {
    // this.currentDate = new Date();
    // console.log("Current Date Value", this.defaultDate);
    //console.log("CUSTOM FIELD Model Value", this.modelValue);
    //console.log("CUSTOM FIELD ITEM", this.item);

    if (
      this.item.editorType == "dxDateBox" &&
      this.item.editorOptions.type == "date" &&
      this.defaultDate
    ) {
      this.currentDate = new Date();
      this.$emit("update:modelValue", this.currentDate);
      console.log(
        "Custom Fields displayFormat",
        this.item.editorOptions.displayFormat
      );
    }

    this.$watch("fieldValue", (newVal, oldVal) => {
      console.log("fieldValue changed called", newVal);
      if (
        this.item.editorType == "dxDateBox" &&
        this.item.editorOptions.type == "date" &&
        newVal instanceof Date &&
        newVal != null
      ) {
        console.log("new DateBox  val", newVal);
        newVal.setHours(6, 0, 0, 0);

        const formattedDate = newVal
          .toLocaleDateString("en-IN", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/\//g, "-");

        console.log("update:modelValue formattedDate val", formattedDate);

        this.$emit("update:modelValue", formattedDate);

        if (this.item.dataField == "transaction_date") {
          this.$emit("onTransactionDateChanged", formattedDate);

          console.log("transaction detail series", formattedDate);
        }
      }
      if (this.item.editorType == "Relate") {
        this.$emit("onRelateValueChanged", newVal);
        this.$emit("update:modelValue", newVal);
      } else {
        console.log("dsd val", newVal);
        this.$emit("update:modelValue", newVal);

        if (this.item.dataField == "transaction_date") {
          this.$emit("onTransactionDateChanged", newVal);

          console.log("Edit  transaction detail series", newVal);
        }
      }
    });
  },
};
</script>

<style>
</style>